<template>
  <div class="roulette_wrap">
    <div class="inner">
      <h1 class="tit_h1">JACKPOT</h1>
      <h2 class="tit_h2">돌리기만 하면 터진다!</h2>
      <p class="tit_tx">누적골드와 등수에 따라 골드가 지급됩니다.</p>
      <p class="tit_tx date">이벤트 기간 : 2021년 1월 5일 ~ 3월 31일</p>
      <dl class="jackpot_money">
        <p class="tx">이벤트 기간 : 2021년 1월 5일 ~ 3월 31일</p>
        <dt class="total">
          <span class="roller" v-if="!updateGold.total">{{ numberWithComma(defaultGold.total.toString()) }}</span>
          <Roller
            v-show="updateGold.total"
            :transition="1"
            :text="updateGold.total || defaultGold.total"
            :isNumberFormat="true"
          />
        </dt>
        <dd class="mega">
          <span class="rank">1등 <em>Mega</em></span>
          <span class="init_gold" v-if="!updateGold.mega">{{ numberWithComma(defaultGold.mega.toString()) }}</span>
          <Roller v-show="updateGold.mega" :transition="1" :text="updateGold.mega || defaultGold.mega" :isNumberFormat="true" />
          <em> Gold</em>
        </dd>
        <dd class="major">
          <span class="rank">2등 <em>Major</em></span>
          <span class="init_gold" v-if="!updateGold.major">{{ numberWithComma(defaultGold.major.toString()) }}</span>
          <Roller v-show="updateGold.major" :transition="1" :text="updateGold.major || defaultGold.major" :isNumberFormat="true" />
          <em> Gold</em>
        </dd>
        <dd class="minor">
          <span class="rank">3등 <em>Minor</em></span>
          <span class="init_gold" v-if="!updateGold.minor">{{ numberWithComma(defaultGold.minor.toString()) }}</span>
          <Roller v-show="updateGold.minor" :transition="1" :text="updateGold.minor || defaultGold.minor" :isNumberFormat="true" />
          <em> Gold</em>
        </dd>
        <dd class="mini">
          <span class="rank">4등 <em>Mini</em></span>
          <span class="init_gold" v-if="!updateGold.mini">{{ numberWithComma(defaultGold.mini.toString()) }}</span>
          <Roller v-show="updateGold.mini" :transition="1" :text="updateGold.mini || defaultGold.mini" :isNumberFormat="true" />
          <em> Gold</em>
        </dd>
      </dl>
      <div class="game_area">
        <div class="exec_area">
          <dl class="info">
            <dt>응모권 획득 방법</dt>
            <dd>캐시충전 5만원당 응모권 1장이 지급됩니다.</dd>
            <!--<dd>연승 스탬프 달성 후 랜덤 아이템에서 획득 가능합니다.</dd>-->
          </dl>
          <div class="ticket">
            <span class="tx">응모권</span>
            <span class="count"><strong>{{ ticket }}</strong> 개</span>
          </div>
          <button type="button" class="btn btn_start" @click="start">응모하기</button>
          <button type="button" class="btn btn_history" @click="ticketHistory">참여내역</button>
          <ul class="tip">
            <li>- 잭팟 골드는 전체 유저의 참여 골드 일부를 누적합니다.</li>
            <li>- 당첨 골드만큼 누적 골드가 차감되며 당첨 골드는 상황에 따라 표시된 금액보다 적을 수 있습니다.</li>
            <li>- 부정한 방법으로 응모권 획득, 잭팟 당첨시에는 제재될 수 있습니다.</li>
          </ul>
        </div>
        <div class="wheel_area">
          <div class="wheel-standard"></div>
        </div>
      </div>
      <div class="ly_result">
        <img :src="imageUrl"/>
        <h3 class="tit">{{ text }}</h3>
        <p>{{ message }}</p>
        <a class="btn_close" href="javascript:;" @click="close()">닫기</a>
      </div>
      <ticketHistory v-if="isHistory"></ticketHistory>
    </div>
  </div>
</template>

<script>

  const slices = [
    {
      text:"1등",
      value:'mega',
      message:"잭팟 1등 Mega에 당첨 되었습니다.",
      background:"#f89c20",
      imageUrl:'/images/item/jackpot1.png',
    },
    {
      text: "꽝!",
      value:'loss',
      message: "아쉽네요! 꽝 입니다",
      background: "#3a0a27",
      imageUrl:'/images/item/none.png',
    },
    {
      text:"2등",
      value:'major',
      message:"잭팟 2등 Major에 당첨 되었습니다.",
      background:"#f89c20",
      imageUrl:'/images/item/jackpot2.png',
    },
    {
      text: "아이템",
      value:'BONUS_3',
      message: "배당 보너스 x 1.03 아이템에 당첨 되었습니다.",
      background: "#3a0a27",
      imageUrl:'/images/item/bonus_103.png',
    },
    {
      text:"3등",
      value:'minor',
      message:"잭팟 3등 Minor에 당첨 되었습니다.",
      background:"#f89c20",
      imageUrl:'/images/item/jackpot3.png',
    },
    {
      text: "아이템",
      value:'STAMP_5',
      message: "5연승 스탬프 아이템에 당첨 되었습니다.",
      background: "#3a0a27",
      imageUrl:'/images/item/stamp_5.png',
    },
    {
      text:"4등",
      value:'mini',
      message:"잭팟 4등 Mini에 당첨 되었습니다.",
      background:"#f89c20",
      imageUrl:'/images/item/jackpot4.png',
    },
    {
      text: "꽝!",
      value:'loss',
      message: "아쉽네요! 꽝 입니다",
      background: "#3a0a27",
      imageUrl:'/images/item/none.png',
    }
  ];

  import jackpotRollingMixins from '@/mixins/jackpot-rolling'
  import ticketHistory from '@/components/event/ticket-history'

  export default {
    name: "roulette",
    mixins: [jackpotRollingMixins],
    components: {
      ticketHistory,
    },
    data() {
      return {
        ticket : window.userInfo.ticket,
        text : '',
        message : '',
        imageUrl : '',
        isHistory : false
      }
    },
    methods: {
      async start() {
        if (!window.userInfo.level) {
          alert('로그인이 필요합니다.');
          location.href='/members/login.php?returnUrl=/event/roulette.php';
          return;
        }

        const {data} = await this._get("/v1/event/roulette");

        if (data.error) {
          alert(data.message);
          return;
        }

        if (data) {
          this.ticket = data.ticket;
        }

        let index = _.findIndex(slices, {'value': data.code});
        if (index > -1) {
          this.text = slices[index].text;
          this.message = slices[index].message;
          this.imageUrl = slices[index].imageUrl
        }

        const go_sound = new Audio('/refer/sound/ladder_bgm.mp3');
        go_sound.play();
        $('.wheel-standard').superWheel('start','value', data.code);
        $('.btn_start').prop('disabled',true);
        $('.btn_history').prop('disabled',true);
      },
      ticketHistory(){
        if (!window.userInfo.level) {
          alert('로그인이 필요합니다.');
          location.href='/members/login.php?returnUrl=/event/roulette.php';
          return;
        }
        this.isHistory = !this.isHistory;
        $('._layer_background').show();
      },
      close(){
        $('._layer_background').hide();
        $('.ly_result').hide();
        $('.btn_start:disabled').prop('disabled',true);
      },
    },
    computed: {
      condition() {
        return {
          page: this.page,
          type: this.type,
          sportsId: this.sportsId,
          gameType: this.gameType,
          status: this.status,
        }
      },
    },
    mounted() {
      $(function(){

        $('.wheel-standard').superWheel({
          slices: slices,
          text : {
            color: "#561840",
            size: 40,
            offset: 12,
            arc: false
          },
          line: {width: 0},
          outer: {
            width: 0
          },
          inner: {
            width: 0
          },
          center: {
            width: 0,
            rotate: true
          },
          marker: {
            background: "#bf0d0d",
            animate: 1
          },
          selector: "value",
          duration: 13000
        });

        const tick_sound = new Audio('/refer/sound/tick.mp3');
        const success_sound = new Audio('/refer/sound/success.mp3');
        const fail_sound = new Audio('/refer/sound/fail.mp3');


        $('.wheel-standard').superWheel('onStep',function(results){
          if (typeof tick_sound.currentTime !== 'undefined')
            tick_sound.currentTime = 0;
            tick_sound.play();
        });

        $('.wheel-standard').superWheel('onComplete',function(results){
          if (results.value === 'loss'){
            fail_sound.play();
          } else {
            success_sound.play();
          }
          $('._layer_background').show();
          $('.ly_result').show();
          $('.btn_start:disabled').prop('disabled',false);
          $('.btn_history:disabled').prop('disabled',false);
        });

      });

      window.getJackpot =  setInterval(async () => {
        try {
          const { data } = await this.$http.get('/v1/event/jackpot');
          this.nameArr.forEach((name) => {
            if (this.updateGold[name] < data.jackpot[name]) {
              this.updateGold[name] += Math.floor(Math.random() * (10 - 1) + 1)
            } else {
              this.updateGold[name] = data.jackpot[name]
            }
          })
        } catch (e) {
          console.log('jackpot fetch Gold error2', e)
        }
      }, 20000);

      confetti.start();

    },
  }
</script>



// WEBPACK FOOTER //
// src/components/event/roulette.vue